import {
  CLEAR_VIEWS,
  PREVIOUS_VIEW,
  SET_ACTIVE_FILTER_ID,
  SET_VIEW,
  SET_CURRENT_TEMPLATE_ID,
  SET_EDITING_TASK_TEMPLATE_ID,
  SET_TEMPLATE_REORDERING_TYPE,
} from 'constants/actions';

function setActiveFilterId(filterId) {
  return {
    type: SET_ACTIVE_FILTER_ID,
    filterId,
  };
}

function setView({ view }) {
  return {
    type: SET_VIEW,
    view,
  };
}

function previousView() {
  return {
    type: PREVIOUS_VIEW,
  };
}

function clearViews() {
  return {
    type: CLEAR_VIEWS,
  };
}

function setCurrentTemplateId(currentTemplateId) {
  return {
    type: SET_CURRENT_TEMPLATE_ID,
    currentTemplateId,
  };
}

function setEditingTaskTemplateId(taskTemplateId) {
  return {
    type: SET_EDITING_TASK_TEMPLATE_ID,
    taskTemplateId,
  };
}

function setTemplateReorderingType(reorderingType) {
  return {
    type: SET_TEMPLATE_REORDERING_TYPE,
    reorderingType,
  };
}

export {
  clearViews,
  previousView,
  setActiveFilterId,
  setCurrentTemplateId,
  setEditingTaskTemplateId,
  setTemplateReorderingType,
  setView,
};
